"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Rectangle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Rectangle_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5H4c-.717 0-1.194 0-1.56.03-.356.03-.518.081-.621.133a1.5 1.5 0 0 0-.656.656c-.052.103-.103.265-.132.62C1 4.306 1 4.783 1 5.5v5c0 .717 0 1.194.03 1.56.03.356.081.518.133.621a1.5 1.5 0 0 0 .656.655c.103.053.265.104.62.133.367.03.844.031 1.561.031h8c.717 0 1.194 0 1.56-.03.356-.03.518-.081.621-.134a1.5 1.5 0 0 0 .655-.655c.053-.103.104-.265.133-.62.03-.367.031-.844.031-1.561v-5c0-.717 0-1.194-.03-1.56-.03-.356-.081-.518-.134-.621a1.5 1.5 0 0 0-.655-.656c-.103-.052-.265-.103-.62-.132C13.194 2.5 12.717 2.5 12 2.5ZM.272 2.865C0 3.4 0 4.1 0 5.5v5c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092C1.9 14.5 2.6 14.5 4 14.5h8c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092C16 12.6 16 11.9 16 10.5v-5c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.093C14.1 1.5 13.4 1.5 12 1.5H4c-1.4 0-2.1 0-2.635.272A2.5 2.5 0 0 0 .272 2.865Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Rectangle_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Rectangle;
exports["default"] = _default;